import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMG } from "@/lib/api";
import { Reveal } from "@/components/site/Reveal";

export const Chef = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-7%", "7%"]);
  return (
    <section ref={ref} id="chef" data-testid="chef-section" className="grain relative overflow-hidden bg-[#F2EAE1] py-20 sm:py-28">
      <div className="relative mx-auto grid max-w-[1400px] items-center gap-12 px-5 sm:px-8 lg:grid-cols-12">
        <div className="order-2 lg:col-span-7">
          <Reveal>
            <p className="eyebrow mb-4 text-[#C85A32]">The mind behind the almanac</p>
            <h2 data-testid="chef-name" className="font-display text-5xl font-light leading-none tracking-tight sm:text-6xl lg:text-7xl"><span className="italic text-[#C85A32]">Kathryn</span></h2>
            <p data-testid="chef-title" className="font-display mt-3 text-2xl font-light italic text-[#4A4543] sm:text-3xl">Juice Alchemist</p>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-[#4A4543] md:text-lg">
              Every recipe in The Recipe Almanac was created and tested by Kathryn on the Slowpour 01. Her approach is simple: seasonal produce, bold colour, and blends that taste as good as they make you feel.
            </p>
            <blockquote className="font-display mt-10 max-w-xl border-l-2 border-[#C85A32] pl-6 text-2xl font-light italic leading-snug sm:text-3xl">
              “Juicing should feel like a ritual, not a chore. Drop it in, slow down, and enjoy the pour.”
            </blockquote>
            <dl className="mt-10 grid max-w-md grid-cols-3 gap-6">
              {[["12", "Original recipes"], ["4", "Chapters"], ["100%", "Tested on the Slowpour"]].map(([n, l]) => (
                <div key={l}>
                  <dt className="font-display text-3xl">{n}</dt>
                  <dd className="mt-1 text-xs text-[#6E6661]">{l}</dd>
                </div>
              ))}
            </dl>
          </Reveal>
        </div>
        <div className="order-1 lg:col-span-5">
          <div className="relative mx-auto aspect-[3/4] max-w-[460px] overflow-hidden rounded-t-full rounded-b-[28px] bg-[#E8DCCD]">
            <motion.img data-testid="chef-image" style={{ y, scale: 1.14 }} src={IMG.kathryn} alt="Kathryn, Juice Alchemist, holding a fresh green juice" className="h-full w-full object-cover object-top" />
            <span className="eyebrow absolute bottom-5 left-5 rounded-full bg-[#FDFBF7]/85 px-3 py-1.5 text-[0.62rem] text-[#181615] backdrop-blur">Juice Alchemist</span>
          </div>
        </div>
      </div>
    </section>
  );
};
